export default {
	'asset linked to risks': 'This asset is directly linked to risks. Remove or reassign them before deleting the asset.',
	'login failed': 'Login failed',
	'invalid password': 'Invalid password',
	'not unique user:': 'User is not unikaalne',
	'invalid email': 'Invalid e-mail',
	'not unique email': 'Email is not unique',
	'invalid idCode': 'Invalid ID code',
	'not unique idCode': 'ID code is not unique',
	'not unique adUser': 'AD username is not unique',
	'audit name': 'Invalid audit name',
	'audit name exists': 'Audit name already exists',
	'auditor level': 'Audit permission denied',
	'domain start': 'Domain must start with "https://"',
	'domain end': 'Domain must end with "/"',
	'domain required': 'Domain is a required field',
	'admin required': 'Admin is a required field',
	'instance required': 'Instance is a required field',
	'invalid email format': 'Invalid email format',
	path: 'Invalid path',
	'api token length': 'API token must be longer than 10 characters',
	'instance ID does not match': 'Instance ID does not match current viewing value or is not the first instance',
	'admin ID does not match': 'Admin ID does not match current active user or is not the first user',
	'email should not be empty': 'Email should not be empty for an active configuration',
	'one active per instance': 'Only one configuration can be active per instance',
	'None of the methods have a domain configuration for exporting': 'None of the methods have a domain configuration for exporting',
	'Could not find a domain configuration for instance': 'Could not find a domain configuration for instance.',
	'401 Unauthorized Client must be authenticated to access this resource request failed Please analyze the request body for more details Status code 401':
		'Client must be authenticated to access this resource.',
	'Information is missing for domain configuration': 'Information is missing for domain configuration.',
	'You must have global administrator rights in order to modify projects':
		'You must have global administrator rights in order to modify projects.',
	'You do not have permission to create issues in this project': 'You do not have permission to create issues in this project.',
	'There was an error with issue creation': 'There was an error with issue creation.',
	'Rule exporting failed': 'Rule exporting failed.',
	'could not delete chosen domain config': 'Could not delete chosen domain config.',
	fieldCannotBeSet: "There is an error with field '{fieldName}'. It might have missing permissions or is configured wrong.",
	'The value "EITS" does not exist for the field "project" request failed Please analyze the request body for more details Status code 400':
		'There is an issue with creating project "EITS", the cause could be that the user does not have permission or project already exists.',
	'Could not find issue by id or key': 'Could not find issue by id or key.',
	'No issue data was provided by request': 'No issue data was provided by request',
	'A project with that name already exists': 'A project with that name already exists. Also check Jira projects trashcan if necessary.',
	'Module exporting failed': 'Module exporting failed.',
	'The request has been rate-limited Please try again later': 'The request has been rate-limited. Please try again later.',
	'Specify an issue type': 'Issue type is missing. Please check if issue types "Task", "Epic", "Sub-Task" exist.',
	'Issue does not exist or you do not have permission to see it request failed Please analyze the request body for more details Status code 400':
		'Issue does not exist or you do not have permission to see it. Issue might be existing in the database, but does not exist in Jira anymore',
	'An error occurred comatlassianidpclientexceptionsAuthorizationException "key""forbidden""context""message""Not admin"':
		'Authorization failure: you do not have admin rights.',
	'a role with the same name already exists': 'A role with the same name already exists!',
	'Request failed with status code 413': 'Error: The file size is too large!',
	'not found': 'Not found',
	'permission denied': 'Permission denied',
	'instance denied': 'Instance denied',
	'file exists': 'File name exists already',
}
